// 04 §5.13 — Dark Matter speed-ups (G-85, G-86): finish the running build or ship batch of a system.
import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';

const HOUR_MS = 3_600_000;

/** G-85: max(1, ceil(perHour × hours saved)); 0 when nothing is left. Shared by server and client. */
export function speedUpCost(msRemaining: number, darkMatterPerHour: number): number {
  if (msRemaining <= 0) return 0;
  return Math.max(1, Math.ceil((darkMatterPerHour * msRemaining) / HOUR_MS));
}

export const speedUpTargetKindSchema = z.enum(['building', 'ships']);
export type SpeedUpTargetKind = z.infer<typeof speedUpTargetKindSchema>;

export const speedUpRequestSchema = z.strictObject({
  targetKind: speedUpTargetKindSchema,
  targetId: idSchema,
  /** The price the client showed; the server charges its own price, never more (COST_CHANGED). */
  expectedCostDarkMatter: z.number().int().positive(),
});
export type SpeedUpRequest = z.infer<typeof speedUpRequestSchema>;

export const speedUpResponseSchema = z.strictObject({
  cost: z.number().int().positive(),
  darkMatter: z.number().int().nonnegative(),
  completedAt: isoDateTimeSchema,
});
export type SpeedUpResponse = z.infer<typeof speedUpResponseSchema>;
